import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconMoreVert.tsx
const OutlinedFilledMoreVert = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.61-126q-24.61 0-42.11-17.37-17.5-17.38-17.5-41.77 0-23.46 17.3-41.66 17.3-18.2 41.59-18.2Q505-245 522-226.78q17 18.21 17 42 0 23.78-16.89 41.28-16.9 17.5-41.5 17.5Zm0-295q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm0-294q-24.61 0-42.11-17.68-17.5-17.67-17.5-42.5 0-24.82 17.3-42.32t41.59-17.5Q505-835 522-817.36t17 42.47q0 24.82-16.89 42.35-16.9 17.54-41.5 17.54Z" })
});
const OutlinedMoreVert = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.61-126q-24.61 0-42.11-17.37-17.5-17.38-17.5-41.77 0-23.46 17.3-41.66 17.3-18.2 41.59-18.2Q505-245 522-226.78q17 18.21 17 42 0 23.78-16.89 41.28-16.9 17.5-41.5 17.5Zm0-295q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm0-294q-24.61 0-42.11-17.68-17.5-17.67-17.5-42.5 0-24.82 17.3-42.32t41.59-17.5Q505-835 522-817.36t17 42.47q0 24.82-16.89 42.35-16.9 17.54-41.5 17.54Z" })
});
const RoundedFilledMoreVert = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.61-126q-24.61 0-42.11-17.37-17.5-17.38-17.5-41.77 0-23.46 17.3-41.66 17.3-18.2 41.59-18.2Q505-245 522-226.78q17 18.21 17 42 0 23.78-16.89 41.28-16.9 17.5-41.5 17.5Zm0-295q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm0-294q-24.61 0-42.11-17.68-17.5-17.67-17.5-42.5 0-24.82 17.3-42.32t41.59-17.5Q505-835 522-817.36t17 42.47q0 24.82-16.89 42.35-16.9 17.54-41.5 17.54Z" })
});
const RoundedMoreVert = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.61-126q-24.61 0-42.11-17.37-17.5-17.38-17.5-41.77 0-23.46 17.3-41.66 17.3-18.2 41.59-18.2Q505-245 522-226.78q17 18.21 17 42 0 23.78-16.89 41.28-16.9 17.5-41.5 17.5Zm0-295q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm0-294q-24.61 0-42.11-17.68-17.5-17.67-17.5-42.5 0-24.82 17.3-42.32t41.59-17.5Q505-835 522-817.36t17 42.47q0 24.82-16.89 42.35-16.9 17.54-41.5 17.54Z" })
});
const SharpFilledMoreVert = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.61-126q-24.61 0-42.11-17.37-17.5-17.38-17.5-41.77 0-23.46 17.3-41.66 17.3-18.2 41.59-18.2Q505-245 522-226.78q17 18.21 17 42 0 23.78-16.89 41.28-16.9 17.5-41.5 17.5Zm0-295q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm0-294q-24.61 0-42.11-17.68-17.5-17.67-17.5-42.5 0-24.82 17.3-42.32t41.59-17.5Q505-835 522-817.36t17 42.47q0 24.82-16.89 42.35-16.9 17.54-41.5 17.54Z" })
});
const SharpMoreVert = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.61-126q-24.61 0-42.11-17.37-17.5-17.38-17.5-41.77 0-23.46 17.3-41.66 17.3-18.2 41.59-18.2Q505-245 522-226.78q17 18.21 17 42 0 23.78-16.89 41.28-16.9 17.5-41.5 17.5Zm0-295q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm0-294q-24.61 0-42.11-17.68-17.5-17.67-17.5-42.5 0-24.82 17.3-42.32t41.59-17.5Q505-835 522-817.36t17 42.47q0 24.82-16.89 42.35-16.9 17.54-41.5 17.54Z" })
});
const componentMap = {
	outlined: OutlinedMoreVert,
	"outlined-fill": OutlinedFilledMoreVert,
	rounded: RoundedMoreVert,
	"rounded-fill": RoundedFilledMoreVert,
	sharp: SharpMoreVert,
	"sharp-fill": SharpFilledMoreVert
};
const IconMoreVert = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconMoreVert };